import React, { useState, useEffect, useRef } from "react";
import "./aggIndex.css";
import wallet from "../../../../../assets/images/walletBalance.png";
import capacity from "../../../../../assets/images/capacity.png";
import WalletBal from "../../../../../assets/images/walletBal.png";
import Caution from "../../../../../assets/images/caution.png";
import Linear from "../../../../../assets/images/linear.png";
import dropOff from "../../../../../assets/images/dropOfff.png";
import pick from "../../../../../assets/images/pick.png";
import avatar from "../../../../../assets/images/avatarr.png";
import calendar from "../../../../../assets/images/calendar.png";
import stat from "../../../../../assets/images/stat.png";
import chart from "../../../../../assets/images/chart.png";
import { useSelector, useDispatch } from "react-redux";
import { statAction } from "../../../../../redux/actions";
import Weight from "./components/weight";
import Cash from "./components/cash";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { switchEndpoint } from "../../../../../redux/actions/endpoints";
import { notificationBus } from "../../../../../notificationBus";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import DropCodeModal from "./components/modals/dropOffCode.js";
import PaymentReqModal from "./components/modals/dropOffCode.js/awaitt";
import PickUpModal from "./components/modals/pickUpMod";
import PaymentSuccessfulModal from "./components/modals/dropOffCode.js/paymentSuccessful";
import PaymentFailedModal from "./components/modals/dropOffCode.js/paymentFailed";
import PaymentRequestModal from "./components/modals/dropOffCode.js/paymentRequest";
import AuthenticateModal from "./components/modals/dropOffCode.js/authenticate";
import ShowPModal from "./components/modals/dropOffCode.js/showP";
import AuthenticateModal2 from "./components/modals/unregistered/authenticate";
import { getCurrentMonthName } from "../../../../../getCurrentMonth";
import { getWeightByMonth } from "../../../../../individualWeight";
import EomTable from "./components/modals/eom/index.js";
import UnregistereEnterCodeModal from "./components/modals/unregistered/enterDropOff.js";
import ShowBailingModal from "./components/modals/bailing/bailingModal.js";
import BailingSuccessfuldModal from "./components/modals/bailing/bailingSuccessful.js";
import { RiErrorWarningFill } from "react-icons/ri";
import { IoIosCheckmarkCircle } from "react-icons/io";
import NewDropCodeModal from "./components/modals/dropOffCode.js/new/DropCodeModal.js";
// import DailyCloseCard from "./components/dailyCloseCard";
import formatCurrencyProperly from "../../../../../formatCurrency.js";
import { storage } from "../../../../../scopedStorage";
import RescheduleModal, {
  RescheduleButton,
} from "../pick/components/modals/reschedule";
import DropOffCard from "../pickUp/components/DropOffCard";

const MainArea = () => {
  const [pricing, setPricing] = useState({});
  const [capacityy, setCapacity] = useState(0);
  const [steps, setSteps] = useState(0);
  const details = JSON.parse(storage.getItem("centerInfo"));
  const dispatch = useDispatch();
  const history = useHistory();
  const [loadingA, setLoadingA] = useState(false);
  const [reschedulePickUp, setReschedulePickUp] = useState(null);
  // Last pick-up list fetch, so a reschedule refreshes the filter currently shown
  const lastPickUpFetch = useRef(null);
  const [loadingR, setLoadingR] = useState(false);
  const [householdDrop, setHouseholdDrop] = useState([]);
  const [dropReq, setDropReq] = useState([]);
  const [dropOffData, setDropOffData] = useState([]);
  const { screen } = useSelector(({ stat }) => stat);
  const [balance, setBalance] = useState({});
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState([]);
  const [stats2, setStats2] = useState([]);
  const [stats3, setStats3] = useState([]);
  const [stats4, setStats4] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [bankCode, setBankCode] = useState(null);
  const [bankAcct, setBankAcct] = useState(null);
  const [isBankLoading, setIsBankLoading] = useState(false);
  const [bankResult, setBankResult] = useState(null);
  const [bankResultStatus, setBankResultStatus] = useState(null);
  const [bailingStat, setBailingStat] = useState([]);
  const [weight, setWeight] = useState(null);
  const [category, setCategory] = useState(null);

  const [valueA, setValueA] = useState(0.0);
  const [valueB, setValueB] = useState(0.0);

  const [driverr, setDriverr] = useState([]);
  const [activeDriverr, setActiveDriverr] = useState([]);

  const [isManual, setIsManual] = useState(false);

  useEffect(() => {
    const manual = storage.getItem("manual_pricing");
    if (manual) {
      setIsManual(manual);
    }
  }, []);

  // console.log(typeof (isManual))

  const switchToCash = () => {
    dispatch(statAction.setStat("cash"));
  };
  const switchToWeight = () => {
    dispatch(statAction.setStat("weight"));
  };

  const [showEom, setShowEom] = useState(false);
  const handleCloseEom = () => setShowEom(false);
  const handleShowEom = () => setShowEom(true);

  const [showDrop, setShowDrop] = useState(false);
  const handleCloseDrop = () => setShowDrop(false);
  const handleShowDrop = () => setShowDrop(true);

  const [showCode, setShowCode] = useState(false);
  const handleCloseCode = () => setShowCode(false);
  const handleShowCode = () => setShowCode(true);

  const [showP, setShowP] = useState(false);
  const handleCloseP = () => setShowP(false);
  const handleShowP = () => setShowP(true);

  const [showBailing, setShowBailing] = useState(false);
  const handleCloseBailing = () => setShowBailing(false);
  const handleShowBailing = () => setShowBailing(true);

  const [showBailingSuccessful, setShowBailingSuccessful] = useState(false);
  const handleCloseBailingSuccessful = () => setShowBailingSuccessful(false);
  const handleShowBailingSuccessful = () => setShowBailingSuccessful(true);

  const [showAwaiting, setShowAwaiting] = useState(false);
  const handleCloseAwaiting = () => setShowAwaiting(false);
  const handleShowAwaiting = () => setShowAwaiting(true);

  const [showPaymentS, setShowPaymentS] = useState(false);
  const handleClosePaymentS = () => setShowPaymentS(false);
  const handleShowPaymentS = () => setShowPaymentS(true);

  const [showPaymentF, setShowPaymentF] = useState(false);
  const handleClosePaymentF = () => setShowPaymentF(false);
  const handleShowPaymentF = () => setShowPaymentF(true);

  const [showPaymentR, setShowPaymentR] = useState(false);
  const handleClosePaymentR = () => setShowPaymentR(false);
  const handleShowPaymentR = () => setShowPaymentR(true);

  const [showAuthenticate, setShowAuthenticate] = useState(false);
  const handleCloseAuthenticate = () => setShowAuthenticate(false);
  const handleShowAuthenticate = () => setShowAuthenticate(true);

  const [showPaymentRR, setShowPaymentRR] = useState(false);
  const handleClosePaymentRR = () => setShowPaymentRR(false);
  const handleShowPaymentRR = () => setShowPaymentRR(true);

  const [showAuthenticate2, setShowAuthenticate2] = useState(false);
  const handleCloseAuthenticate2 = () => setShowAuthenticate2(false);
  const handleShowAuthenticate2 = () => setShowAuthenticate2(true);

  const getAllReq = () => {
    setLoadingA(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/all-dropoff-requests`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // console.log(response.data.data);
        setHouseholdDrop(response.data.data);
        setLoadingA(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setHouseholdDrop([]);
        setLoadingA(false);
      });
  };

  const getHouseholdReq = () => {
    setLoadingA(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/dropoff-requests/household`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data.data;
        setHouseholdDrop(result);
        setLoadingA(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        console.log(error);
        setHouseholdDrop([]);
        setLoadingA(false);
      });
  };

  const getAgentReq = () => {
    setLoadingA(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/dropoff-requests/agents`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data.data;
        setHouseholdDrop(result);
        setLoadingA(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setHouseholdDrop([]);
        setLoadingA(false);
      });
  };

  const getCorporateReq = () => {
    setLoadingA(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/dropoff-requests/corporate`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data.data;
        setHouseholdDrop(result);
        setLoadingA(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setHouseholdDrop([]);
        setLoadingA(false);
      });
  };

  const getCharityReq = () => {
    setLoadingA(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/dropoff-requests/charity`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data.data;
        setHouseholdDrop(result);
        setLoadingA(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setHouseholdDrop([]);
        setLoadingA(false);
      });
  };

  const getPickUpdReq = () => {
    lastPickUpFetch.current = getPickUpdReq;
    setLoadingR(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/all-pickup-requests`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // console.log(response.data);
        setDropReq(response.data.data);
        setLoadingR(false);
      })
      .catch((error) => {
        toast.error(error.response, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoadingR(false);
      });
  };

  const getPickupHouseholdReq = () => {
    lastPickUpFetch.current = getPickupHouseholdReq;
    // setChecked1(false);
    setLoadingR(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/pickup-requests/household`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setDropReq(response.data.data);
        const result = response.data.data;
        // const total = response.data.meta.last_page;
        // setPageCount2(total);
        setLoadingR(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getPickupCorporateReq = () => {
    lastPickUpFetch.current = getPickupCorporateReq;
    // setChecked4(false);
    setLoadingR(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/pickup-requests/corporate`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setDropReq(response.data.data);
        // const result = response.data.data;
        // const total = response.data.meta.last_page;
        // setPageCount4(total);
        setLoadingR(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setDropReq([]);
        setLoadingR(false);
      });
  };

  const getPickupCharityReq = () => {
    lastPickUpFetch.current = getPickupCharityReq;
    setLoadingR(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/pickup-requests/charity`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setDropReq(response.data.data);
        // const result = response.data.data;
        // const total = response.data.meta.last_page;
        // setPageCount4(total);
        setLoadingR(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setDropReq([]);
        setLoadingR(false);
      });
  };

  const getPickupAgentReq = () => {
    lastPickUpFetch.current = getPickupAgentReq;
    // setChecked1(false);
    setLoadingR(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/pickup-requests/agents`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // console.log(response.data.data);
        setDropReq(response.data.data);
        // const result = response.data.data;
        // const total = response.data.meta.last_page;
        // setPageCount3(total);
        setLoadingR(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoadingR(false);
      });
  };

  const getDropOff = async (code) => {
    try {
      const token = storage.getItem("token");
      const response = await axios.get(
        `${switchEndpoint}/aggregation-center/single-dropoff/${code}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log("api called")
      const { data } = response.data;
      setDropOffData(data);
      localStorage.setItem("id", data.id);
      localStorage.setItem("reference", JSON.stringify(data));
      localStorage.setItem("dropOff", JSON.stringify(data.dropoff_details));

      const { status, owner } = data;

      if (status === "initiated" && owner.user_type === "unregistered") {
        handleShowPaymentR();
        return;
      }

      switch (status) {
        case "scheduled":
          handleShowDrop();
          break;
        case "initiated":
          handleShowAwaiting();
          break;
        case "accepted":
          handleShowPaymentR();
          break;
      }
    } catch (error) {
      // toast.error("Error fetching data ...", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   pauseOnHover: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      return;
    }
  };

  const getCapacity = () => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(
        `${switchEndpoint}/aggregation-center/dashboard-stats/center-capacity`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        // console.log(response.data.overall_capacity);
        setCapacity(response.data.overall_capacity);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getWalletBalance = () => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/fetch-balance`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // console.log(response.data);
        setBalance(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      });
  };

  const calculateWeight = (method1, method2) => {
    const currentMonthName = getCurrentMonthName();
    const desiredMonth = currentMonthName;
    const weightForMonth1 = getWeightByMonth(desiredMonth, method1);
    if (weightForMonth1) {
      setValueA(Number(weightForMonth1));
    }

    const weightForMonth2 = getWeightByMonth(desiredMonth, method2);
    if (weightForMonth2) {
      setValueB(Number(weightForMonth2));
    }
  };

  const getStat = () => {
    const token = storage.getItem("token");
    axios
      .get(
        `${switchEndpoint}/aggregation-center/dashboard-stats/agent-weights`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setStats(response.data);
        let response2 = response.data;
        axios
          .get(
            `${switchEndpoint}/aggregation-center/dashboard-stats/household-weights`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((response) => {
            setStats2(response.data);
            calculateWeight(response.data, response2);
          })
          .catch((error) => {
            toast.error(error.response.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              pauseOnHover: true,
              progress: undefined,
              theme: "light",
            });
          });

        // console.log(response.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getChat = () => {
    const token = storage.getItem("token");
    axios
      .get(
        `${switchEndpoint}/aggregation-center/dashboard-stats/agent-payments`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setStats3(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
        // toast.error(error.response.data.message, {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   pauseOnHover: true,
        //   progress: undefined,
        //   theme: "light",
        // });
      });
  };

  const getChat2 = () => {
    const token = storage.getItem("token");
    axios
      .get(
        `${switchEndpoint}/aggregation-center/dashboard-stats/household-payments`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setStats4(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getDrivers = () => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/drivers`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // console.log(response.data);
        const results = response.data;
        setDriverr(response.data);
        let active = response.data.filter(
          (x) => x.last_login_status === "active"
        );
        let inactive = response.data.filter(
          (x) => x.last_login_status === "inactive"
        );

        localStorage.setItem("driversProp", JSON.stringify(active));
        // setActiveDrivers(active);
        setActiveDriverr(active);
        // setInactiveDrivers(inactive);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getAllPricing = () => {
    setLoadingA(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/all-waste-categories`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setPricing(response.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoadingA(false);
      });
  };

  // const getAllPricing2 = (id) => {
  //   setLoadingA(true);
  //   const token = storage.getItem("token");
  //   axios
  //     .get(`${switchEndpoint}/state-waste-categories/${id}`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((response) => {
  //       // console.log("state categories ==>", response.data);
  //       setPricing(response.data);
  //     })
  //     .catch((error) => {
  //       toast.error(error.response.data.message, {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         pauseOnHover: true,
  //         progress: undefined,
  //         theme: "light",
  //       });
  //       setLoadingA(false);
  //     });
  // };

  // const state_id = storage.getItem("state_id");

  const getBank = () => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/financial-services/banks`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const sortedBanks = [...response.data].sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        );
        setBankList(sortedBanks);
        // setBankList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      });
  };

  const validateBank = (code, acct) => {
    setIsBankLoading(true);
    const token = storage.getItem("token");
    const payload = {
      bank_code: code,
      account_number: acct,
    };
    axios
      .post(
        `${switchEndpoint}/financial-services/search-external-bank`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setBankResult(response.data);
        setBankResultStatus(response?.status);
        // console.log(response?.status);
        setIsBankLoading(false);
      })
      .catch((error) => {
        setBankResultStatus(error?.status);
        setIsBankLoading(false);
      });
  };

  const getBailingStat = () => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/aggregation-center/bailing-stats`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // console.log(response.data);
        setBailingStat(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  useEffect(() => {
    getBank();
    getAllPricing();
    getBailingStat();
    // getAllPricing2(state_id);
    getWalletBalance();
    getAllReq();
    getPickUpdReq();
    getCapacity();
    getStat();
    getChat();
    getChat2();
    getDrivers();
    // calculateWeight();
  }, []);

  // Refresh the drop-off requests list on any notification — e.g. a new
  // drop-off request coming in — rather than polling on a timer.
  useEffect(() => {
    const unsubscribe = notificationBus.subscribe(() => getAllReq());
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log(steps);
  useEffect(() => {
    if (showAwaiting) {
      setSteps(1);
    } else {
      setSteps(0);
    }
  }, [showAwaiting]);

  useEffect(() => {
    if (bankCode && bankAcct?.length === 10) {
      setBankResult(null);
      validateBank(bankCode, bankAcct);
    } else {
      setBankResult(null);
      setBankResultStatus(null);
    }
  }, [bankCode, bankAcct]);

  return (
    <main>
      <div className="main__container">
        <div className="separatingDiv">
          <div>
            <div className="main__cards">
              <div className="cardsz">
                <div className="flex justify-content-center align-items-center">
                  <div className="cards_img1" style={{ margin: "0 auto" }}>
                    <img src={capacity} alt="cap" />
                  </div>
                  <div className="card_inners">
                    <p className="card_inners_p1 pb-2 mb-0 ml-2">
                      Loose Pet Capacity
                    </p>
                    {/* {loading ? (
                      <span className="d-flex justify-content-center">
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </span>
                    ) : (
                      <h6 className="card_inners_amount1 text-center mb-0">
                        <span style={{ color: "#c4da00" }}>
                          {bailingStat?.current_loose_pet}
                        </span>{" "}
                        <span style={{ fontWeight: "400", fontSize: "18px" }}>
                          of{" "}
                        </span>{" "}
                        {bailingStat?.loose_pet_threshold}
                        <span style={{ fontWeight: "400", fontSize: "18px" }}>
                          tonnes
                        </span>
                      </h6>
                    )} */}

                    <div className="mt-1 d-flex align-items-center justify-content-center">
                      <div className="d-flex align-items-center">
                        <div>
                          {bailingStat?.loose_pet_percentage >= "50" ? (
                            <RiErrorWarningFill size={20} color="#FF5353" />
                          ) : (
                            <IoIosCheckmarkCircle size={20} color="#C4DA00" />
                          )}
                        </div>
                        <p className="card_inners_p1 pb-2 mb-0 ml-2 mt-2">
                          {`${bailingStat?.loose_pet_percentage}% capacity reached`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cardsz">
                <div className="flex justify-content-center align-items-center">
                  <div className="cards_img1" style={{ margin: "0 auto" }}>
                    <img src={Linear} alt="cap" />
                  </div>

                  <div className="card_inners">
                    <p className="card_inners_p1 pb-2 mb-0 ml-2">
                      Bailed Recyclables Capacity
                    </p>
                    {/* {loading ? (
                      <span className="d-flex justify-content-center">
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </span>
                    ) : (
                      <h6 className="card_inners_amount1 text-center mb-0">
                        <span style={{ color: "#c4da00" }}>
                          {bailingStat?.current_bailing}
                        </span>{" "}
                        <span style={{ fontWeight: "400", fontSize: "18px" }}>
                          of{" "}
                        </span>{" "}
                        {bailingStat?.bailing_threshold}
                        <span style={{ fontWeight: "400", fontSize: "18px" }}>
                          tonnes
                        </span>
                      </h6>
                    )} */}

                    <div className="mt-1 d-flex align-items-center justify-content-center">
                      <div className="d-flex align-items-center">
                        <div>
                          {bailingStat?.bailing_percentage >= "50" ? (
                            <RiErrorWarningFill size={20} color="#FF5353" />
                          ) : (
                            <IoIosCheckmarkCircle size={20} color="#C4DA00" />
                          )}
                        </div>
                        <p className="card_inners_p1 pb-2 mb-0 ml-2 mt-2">
                          {`${bailingStat?.bailing_percentage}% capacity reached`}
                        </p>
                      </div>
                    </div>
                    <div className="mt-1">
                      <button
                        type="button"
                        className="btn loginBtn2 btn-sm btn-block"
                        onClick={() => {
                          handleShowBailing();
                        }}
                        // disabled={loading}
                      >
                        Bailing Activity
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="requests">
              <div className="cardss">
                <div className="d-flex align-items-center justify-content-between items-center">
                  <div className="d-flex align-items-center">
                    <div className="cards_img1">
                      <img src={WalletBal} alt="cap" />
                    </div>
                    <div>
                      <p className="card_inners_p mb-0 ml-2 text-left">
                        Wallet Balance
                      </p>
                      {loading ? (
                        <span className="" style={{ margin: "0 auto" }}>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        </span>
                      ) : (
                        <h3 className="card_inners_amount mb-0 text-center">
                          {balance?.chams_wallet
                            ? `₦${formatCurrencyProperly(balance?.chams_wallet?.account_balance)}`
                            : `₦${0}`}
                        </h3>
                      )}
                    </div>
                  </div>
                  <div className="d-flex items-center justify-center align-items-center">
                    <p className="card_inners_p1 mb-0">View Details</p>
                    <div className="ml-2">
                      <div
                        className="buttonLike"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          // console.log(req)
                        }}
                      >
                        <span
                          style={{
                            color: "#fff",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "18px",
                          }}
                        >
                          &#62;
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* EOM Payment Due — replaced with the Daily Close reconciliation status card */}
                {/* <div className="d-flex align-items-center justify-content-between items-center mt-5">
                  <div className="d-flex align-items-center">
                    <div className="cards_img1">
                      <img src={Clock} alt="cap" />
                    </div>
                    <div>
                      <p className="card_inners_p mb-0 ml-2 text-left">
                        EOM Payment Due
                      </p>
                      <p className="card_inners_p mb-0 ml-2 text-left card_inners_amount">
                        N0.00
                      </p>
                    </div>
                  </div>
                  <div className="d-flex items-center justify-center align-items-center">
                    <p className="card_inners_p1 mb-0">View Details</p>
                    <div className="ml-2">
                      <div
                        className="buttonLike"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          // console.log(req)
                        }}
                      >
                        <span
                          style={{
                            color: "#fff",
                            textAlign: "center",
                            margin: "auto",
                            fontSize: "18px",
                          }}
                        >
                          &#62;
                        </span>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <DailyCloseCard /> */}
              </div>
            </div>

            <div className="requests">
              <div className="cardss">
                <div className="requestFlex mb-0">
                  <div className="d-flex align-items-center">
                    <div className="dropOff_image">
                      <img src={dropOff} alt="drop" />
                    </div>
                    <div>
                      <h4 className="dropOff__title ml-2 mt-1">
                        Drop Off Requests
                      </h4>
                    </div>
                  </div>
                  <div>
                    <p className="mb-0">{`${householdDrop.length} requests`}</p>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="ml-3">
                    <div className="spaceTop">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio1drop"
                          value="option1"
                          onClick={() => {
                            getAllReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio1drop">
                          All
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio2drop"
                          value="option2"
                          onClick={() => {
                            getHouseholdReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio2drop">
                          Household
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio3drop"
                          value="option3"
                          onClick={() => {
                            getAgentReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio3drop">
                          Agent
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio4drop"
                          value="option3"
                          onClick={() => {
                            getCorporateReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio4drop">
                          Corporate Users
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio5drop"
                          value="option5"
                          onClick={() => {
                            getCharityReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio5drop">
                          Charity
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {loadingA ? (
                  <div className="card_inners_amount mt-4 text-center">
                    <span>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </span>
                  </div>
                ) : (
                  <div>
                    {householdDrop?.length !== 0 ? (
                      householdDrop.map((req) => (
                        <DropOffCard
                          key={req?.id || req?.code}
                          dropOff={req}
                          onView={getDropOff}
                        />
                      ))
                    ) : (
                      <p className="dropOffEmpty">No scheduled drop offs</p>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="requests">
              <div className="cardss">
                <div className="requestFlex">
                  <div className="d-flex align-items-center">
                    <div className="dropOff_image">
                      <img src={pick} alt="pick" />
                    </div>
                    <h4 className="dropOff__title mt-1">Pick Up Requests</h4>
                  </div>
                  <div>
                    <p className="mb-0">{`${dropReq.length} requests`}</p>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="ml-3">
                    <div className="spaceTop">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio1"
                          value="option1"
                          onClick={() => {
                            getPickUpdReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio1">
                          All
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio2"
                          value="option2"
                          onClick={() => {
                            getPickupHouseholdReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio2">
                          Household
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio3"
                          value="option3"
                          onClick={() => {
                            getPickupAgentReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio3">
                          Agent
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio3"
                          value="option3"
                          onClick={() => {
                            getPickupCorporateReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio3">
                          Corporate Users
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="inlineRadioOptions"
                          id="inlineRadio4"
                          value="option"
                          onClick={() => {
                            getPickupCharityReq();
                          }}
                        />
                        <label class="form-check-label" for="inlineRadio3">
                          Charity
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {loadingR ? (
                  <div className="card_inners_amount text-center">
                    <span>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </span>
                  </div>
                ) : (
                  <div>
                    {dropReq?.length !== 0 ? (
                      dropReq.map((req) => {
                        return (
                          <div key={req.id}>
                            <div className="reqBg">
                              <div className="d-flex align-items-center justify-content-between">
                                <div>
                                  <div className="d-flex align-items-center">
                                    <img src={avatar} alt="vatar" />
                                    <p className="mb-0 ml-2">
                                      {req?.owner?.name}
                                    </p>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center">
                                  <div className="d-flex">
                                    <div>
                                      <img src={calendar} alt="calendar" />
                                    </div>
                                    <p
                                      className="mb-0 ml-2"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {req?.date_type}
                                    </p>
                                  </div>
                                  <RescheduleButton
                                    onClick={() => setReschedulePickUp(req)}
                                  />
                                  <div className="ml-2">
                                    <div
                                      className="buttonLike"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "pickUp",
                                          JSON.stringify(req)
                                        );
                                        handleShowP();
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#fff",
                                          textAlign: "center",
                                          margin: "auto",
                                        }}
                                      >
                                        &#62;
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-center">No Data Available</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="requests">
              {screen === "weight" && (
                <Weight
                  stat={stat}
                  switchToCash={switchToCash}
                  switchToWeight={switchToWeight}
                  chart={chart}
                  stats={stats}
                  stats2={stats2}
                  valueA={valueA}
                  valueB={valueB}
                />
              )}
              {screen === "cash" && (
                <Cash
                  stat={stat}
                  switchToCash={switchToCash}
                  switchToWeight={switchToWeight}
                  chart={chart}
                  stats3={stats3}
                  stats4={stats4}
                />
              )}
            </div>

            {/* <div className="requests">
              <div className="cardss">
                <div className="requestFlex mb-2">
                  <div className="d-flex align-items-center">
                    <div className="dropOff_image">
                      <img src={dropOff} alt="pick" />
                    </div>
                    <h4 className="dropOff__title mt-1">Active Drivers</h4>
                  </div>
                  <div>
                    <p className="mb-0">{`${activeDriverr.length} / ${driverr.length} drivers active`}</p>
                  </div>
                </div>
                <div className="mapImage ml-4 mr-3" style={{ height: "85vh" }}>
                  <MapsUI />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* <DropCodeModal */}
      <NewDropCodeModal
        showDrop={showDrop}
        handleCloseDrop={handleCloseDrop}
        dropOffData={dropOffData}
        handleShowAwaiting={handleShowAwaiting}
        steps={steps}
        setSteps={setSteps}
        handleShowPaymentRR={handleShowPaymentRR}
        pricing={pricing}
        isManual={isManual}
        handleShowPaymentR={handleShowPaymentR}
        getDropOff={getDropOff}
      />

      <UnregistereEnterCodeModal
        showCode={showCode}
        handleCloseCode={handleCloseCode}
        handleShowDrop={handleShowDrop}
        getHouseholdReq={getHouseholdReq}
        getAgentReq={getAgentReq}
        setDropOffData={setDropOffData}
      />

      <PaymentReqModal
        showAwaiting={showAwaiting}
        handleCloseAwaiting={handleCloseAwaiting}
        dropOffData={dropOffData}
        steps={steps}
        setSteps={setSteps}
        getDropOff={getDropOff}
        getAllReq={getAllReq}
        handleShowPaymentR={handleShowPaymentR}
        handleCloseDrop={handleCloseDrop}
      />

      <PaymentRequestModal
        showPaymentR={showPaymentR}
        handleClosePaymentR={handleClosePaymentR}
        handleShowAuthenticate={handleShowAuthenticate}
        bankList={bankList}
        setBankAcct={setBankAcct}
        setBankCode={setBankCode}
        bankResult={bankResult}
        isBankLoading={isBankLoading}
        bankResultStatus={bankResultStatus}
        bankCode={bankCode}
        bankAcct={bankAcct}
        getDropOff={getDropOff}
        setBankResult={setBankResult}
        setBankResultStatus={setBankResultStatus}
      />

      <PaymentSuccessfulModal
        showPaymentS={showPaymentS}
        handleClosePaymentS={handleClosePaymentS}
      />

      <PaymentFailedModal
        showPaymentF={showPaymentF}
        handleClosePaymentF={handleClosePaymentF}
      />

      <AuthenticateModal
        showAuthenticate={showAuthenticate}
        handleCloseAuthenticate={handleCloseAuthenticate}
        handleShowPaymentF={handleShowPaymentF}
        handleShowPaymentS={handleShowPaymentS}
        bankCode={bankCode}
        bankResult={bankResult}
        bankAcct={bankAcct}
        setBankAcct={setBankAcct}
        setBankCode={setBankCode}
      />

      <PickUpModal showP={showP} handleCloseP={handleCloseP} />

      <EomTable showEom={showEom} handleCloseEom={handleCloseEom} />

      <ShowPModal
        showPaymentRR={showPaymentRR}
        handleClosePaymentRR={handleClosePaymentRR}
        handleShowAuthenticate2={handleShowAuthenticate2}
      />

      <ShowBailingModal
        showBailing={showBailing}
        handleCloseBailing={handleCloseBailing}
        handleShowBailingSuccessful={handleShowBailingSuccessful}
        bailingStat={bailingStat}
        weight={weight}
        setWeight={setWeight}
        category={category}
        setCategory={setCategory}
      />

      <BailingSuccessfuldModal
        showBailingSuccessful={showBailingSuccessful}
        handleCloseBailingSuccessful={handleCloseBailingSuccessful}
        weight={weight}
        bailingStat={bailingStat}
        setWeight={setWeight}
        category={category}
      />

      <AuthenticateModal2
        showAuthenticate2={showAuthenticate2}
        handleCloseAuthenticate2={handleCloseAuthenticate2}
        dropOffData={dropOffData}
        handleShowPaymentS={handleShowPaymentS}
        handleShowPaymentF={handleShowPaymentF}
      />

      <RescheduleModal
        show={!!reschedulePickUp}
        handleClose={() => setReschedulePickUp(null)}
        pickUp={reschedulePickUp}
        onRescheduled={() => (lastPickUpFetch.current || getPickUpdReq)()}
      />
    </main>
  );
};

export default MainArea;
